<script setup lang="ts">
defineProps<{
  type?: 'text' | 'svg' | 'card' | 'dropdown'
  lines?: number
}>()
</script>

<template>
  <div class="skeleton" :class="`skeleton--${type ?? 'text'}`">
    <template v-if="type === 'svg'">
      <div class="skeleton__svg"></div>
    </template>
    <template v-else-if="type === 'card'">
      <div class="skeleton__card" v-for="i in (lines ?? 3)" :key="i">
        <div class="skeleton__card-img"></div>
        <div class="skeleton__card-lines">
          <div class="skeleton__line" style="width: 60%"></div>
          <div class="skeleton__line" style="width: 40%"></div>
          <div class="skeleton__line" style="width: 30%"></div>
        </div>
      </div>
    </template>
    <template v-else-if="type === 'dropdown'">
      <div class="skeleton__line" style="width: 100%; height: 42px; border-radius: 6px;"></div>
    </template>
    <template v-else>
      <div
        v-for="i in (lines ?? 3)"
        :key="i"
        class="skeleton__line"
        :style="{ width: `${70 + Math.random() * 30}%` }"
      ></div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.skeleton {
  &__line {
    height: 14px;
    background: linear-gradient(90deg, #eee 25%, #e0e0e0 50%, #eee 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
    margin-bottom: 8px;
  }

  &__svg {
    width: 100%;
    aspect-ratio: 4/3;
    background: linear-gradient(90deg, #eee 25%, #e0e0e0 50%, #eee 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 8px;
  }

  &__card {
    display: flex;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid #eee;
    border-radius: 8px;
    margin-bottom: 0.75rem;
  }

  &__card-img {
    width: 80px;
    height: 80px;
    background: linear-gradient(90deg, #eee 25%, #e0e0e0 50%, #eee 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 6px;
    flex-shrink: 0;
  }

  &__card-lines {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
  }
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
